import { gql } from '@apollo/client';

export const GET_PARTNERS_DASHBOARD = gql`
  query v1_partners_dashboard($prm: indexInt!) {
    v1_partners_dashboard(prm: $prm) {
      items {
        count
        date
        name
        net
        product_id
      }
      month {
        count
        total
        trips
      }
      yesterday {
        count
        total
        trips
      }
      today {
        count
        total
        trips
      }
      previosMonth {
        count
        total
        trips
      }
      total {
        count
        total
      }
    }
  }
`;

export const GET_ACTIVITIES_REPORT = gql`
  query v1_reports_getAnalyticsActivity(
    $prm: v1_reports_getAnalyticsActivityInput!
  ) {
    v1_reports_getAnalyticsActivity(prm: $prm) {
      activityId
      date
      listPositionAvg
      list_view
      partnerId
      promotion_purchase
      promotion_purchase_total
      promotion_select
      promotion_view
      view
    }
  }
`;
